import sound from './select.wav';export default sound;